export default __webpack_public_path__ + "static/media/add-fill.f88d1f4e.svg";